/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type OrganizationPreferences = {
  /**
   * The preferred mass unit for the organization
   */
  mass_unit?: OrganizationPreferences.mass_unit;
  /**
   * The preferred currency for the organization
   */
  currency?: OrganizationPreferences.currency;
  /**
   * The method used for composition calculations
   */
  composition_calculation_method?: OrganizationPreferences.composition_calculation_method;
};
export namespace OrganizationPreferences {
  /**
   * The preferred mass unit for the organization
   */
  export enum mass_unit {
    KG = "kg",
    OZ = "oz",
  }
  /**
   * The preferred currency for the organization
   */
  export enum currency {
    USD = "USD",
    CAD = "CAD",
    GBP = "GBP",
    EUR = "EUR",
    AUD = "AUD",
  }
  /**
   * The method used for composition calculations
   */
  export enum composition_calculation_method {
    AVERAGE_OF_RANGE = "average_of_range",
    MAXIMUM_OF_RANGE = "maximum_of_range",
    NORMALIZE_SUM_OF_AVERAGES = "normalize_sum_of_averages",
    NORMALIZE_SUM_OF_MAXIMUMS = "normalize_sum_of_maximums",
  }
}
